module.exports = "query createSalesDetailsExport($adviceRequestId:String!,$view:String){createSalesDetailsExport(adviceRequestId:$adviceRequestId,view:$view)}"